import { createContext, useContext, useEffect, useState } from "react";

import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((response) => setUser(response.data))
      .catch(() => localStorage.removeItem("wbc_access_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (data) => {
    localStorage.setItem("wbc_access_token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      localStorage.removeItem("wbc_access_token");
      setUser(null);
    }
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error("useAuth muss innerhalb von AuthProvider verwendet werden.");
  }
  return value;
}
